import { render, staticRenderFns } from "./AddOrderDialog.vue?vue&type=template&id=1d8f7e1e&scoped=true"
import script from "./AddOrderDialog.vue?vue&type=script&lang=js"
export * from "./AddOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./AddOrderDialog.vue?vue&type=style&index=0&id=1d8f7e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8f7e1e",
  null
  
)

export default component.exports